import { DesignerEntity } from '../../types';

export enum DesignersListingActions {
  FetchListingBegin = 'DESIGNERS/FETCH_LISTING/BEGIN',
  FetchListingSuccess = 'DESIGNERS/FETCH_LISTING/SUCCESS',
  FetchListingError = 'DESIGNERS/FETCH_LISTING/ERROR',
}

export interface DesignersListingStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  designers: DesignerEntity[];
}
